const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 * @type {Array}
 * @private
 */
let _allArtists = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
const ArtistsStore = assign({}, ModelStore, {
    getAllArtists: function () {
        return _allArtists;
    }
});

/**
 * Event Listeners
 */
ArtistsStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'ARTISTS_LISTED':
            _allArtists = action.data;

            ArtistsStore.emitChange();
            break;
    }
});

module.exports = ArtistsStore;
